module.exports = "/_next/static/images/daypass-15c0820846f67826cf135fc40f1c3915.jpg";